import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { MarketingEntryPoint } from "../../advanced-flow/schemas/marketing/marketing";

export const subscribeToEmailMarketingSchema = {
  name: "subscribeToEmailMarketing" as const,
  input: z.object({
    email: z.string(),
    entryPoint: createEnum(MarketingEntryPoint),
    agreementText: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
